import { ChevronsUp, ChevronUp, Minus, ChevronDown } from "lucide-react";

export const IMPORTANCE = {
  critical: { label: "Critical", icon: ChevronsUp, color: "#DC2626", badge: "bg-rose-100 text-rose-700 border-rose-200", order: 0 },
  high: { label: "High", icon: ChevronUp, color: "#EA580C", badge: "bg-amber-100 text-amber-700 border-amber-200", order: 1 },
  normal: { label: "Normal", icon: Minus, color: "#0093D6", badge: "bg-sky-100 text-sky-700 border-sky-200", order: 2 },
  low: { label: "Low", icon: ChevronDown, color: "#64748B", badge: "bg-slate-100 text-slate-600 border-slate-200", order: 3 },
};
export const importanceMeta = (k) => IMPORTANCE[k] || IMPORTANCE.normal;
export const IMPORTANCE_KEYS = ["critical", "high", "normal", "low"];

export const STATUS_LABEL = {
  not_started: "Not Started", in_progress: "In Progress", waiting: "Waiting",
  completed: "Completed", cancelled: "Cancelled",
};
export const PROJECT_STATUS = {
  planning: "Planning", active: "Active", on_hold: "On Hold", completed: "Completed", cancelled: "Cancelled",
};

export const CHART_COLORS = ["#006090", "#0093D6", "#38BDF8", "#818CF8", "#F59E0B", "#10B981",
  "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6", "#F97316", "#64748B", "#22C55E"];

export const fmtDate = (d) => d ? new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "";
export const fmtDateTime = (d) => d ? new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
export const todayISO = () => new Date().toISOString().slice(0, 10);
